import * as React from "react";
import {
    Card, CardHeader, CardText, CardBody
} from 'reactstrap';

class CardProps {
    public numberValue: number;
    public headerText: string;
    public className?: string;
    public icono?: JSX.Element;
}

export function NumericCardBox(props: CardProps): JSX.Element {

    return (
        <Card className={props.className ?? props.numberValue > 0 ? "card-ok" : "card-ko"}>
            <CardBody className={"text-center"}>
                <CardText>
                    {props.numberValue.toString()}
                    {props.icono != null &&
                        <span style={{ marginLeft: 10 }}>
                            {props.icono}
                        </span>}
                </CardText>
            </CardBody>
            <CardHeader>{props.headerText}</CardHeader>
        </Card>
    );
}
